<template>
	<main v-if="artifactExists" class="page single-artifact menu-margin no-padding full-height relative" ref="myArtifact">
		<div class="supplementary-artifact-cont">
			<section :class="'artifact-cont grid-horizontal '+(isMobile ? '' : 'full-height')">
				<div :class="'supplementary-data-cont '+(thereAreSomeRelated ? 'with-margin' : '')">
					<div class="artifact-data-cont stack-vertical relative">
						<p class="pointer artifact-back-page" @click="goToArchive">{{$t('reperto_pulsante_ritorno_collezione').toUpperCase()}}</p>
						<!-- <base-icon v-if="!isMobile" class="artifact-back-page pointer" @click="goBack" name="back_arrow"/> -->
						<div class="artifact-data stack-vertical">
							<div class="artifact-data-main-group stack-vertical">
								<h3 class="font-bold">{{artifact.data.attributes.titolo}}</h3>
								<div class="artifact-data-group stack-vertical">
									<p v-for="m in groupMetadata1.filter(el => artifact.data.attributes[el.key])">{{artifact.data.attributes[m.key]}}</p>
								</div>
							</div>
							<div class="artifact-data-group artifact-paths stack-vertical">
								<p class="font-medium capitalize-first">{{$t('where_to_find')}}</p>
								<div v-if="artifactPaths.length" class="stack-vertical">
									<p v-for="ap in artifactPaths">{{utils.localizedScrollyTitle(ap, scrollies, $i18n.locale)}}</p>
								</div>
								<p v-else class="capitalize-first">{{$t('reperto_data_non_esposto')}}</p>
							</div>
							<div class="stack-horizontal artifact-button-actions">
								<base-icon v-for="btn in buttonActions.buttons" :name="btn.icon" :class="'artifact-button-action pointer '+(btn.enabled ? '' : 'disabled')" @click="clickButton(btn.name)"></base-icon>
								<base-icon v-if="artifact.data.attributes.open_access" name="public-domain" class="artifact-public-domain-icon"></base-icon>
							</div>
							<div class="artifact-desc stack-vertical">
								<p class="font-medium capitalize-first">{{$t('artifact_description')}}</p>
								<p v-html="utils.markdownToHtml(artifact.data.attributes.descrizione)"></p>
							</div>
							<div class="artifact-data-group artifact-metadata-cont stack-vertical">
								<p class="capitalize-first font-caption-medium artifact-metadata-title">{{$t('reperto_dettagli')}}</p>
								<template v-for="m in groupMetadata2">
									<div v-if="artifact.data.attributes[m.key] && m.key !== 'pagina_opera' && artifact.data.attributes[m.key] && m.key !== 'link_label'" class="artifact-metadata grid-horizontal">
										<div class="font-caption-medium metadata-voice capitalize-first">{{m.value}}</div>
										<div class="font-caption">{{artifact.data.attributes[m.key]}}</div>
									</div>
									<div v-if="artifact.data.attributes['pagina_opera'] && artifact.data.attributes['link_label'] && m.key == 'pagina_opera'" class="artifact-metadata grid-horizontal">
										<div class="font-caption-medium metadata-voice capitalize-first">{{m.value}}</div>
										<a class="font-caption" style="text-decoration: underline;" :href="artifact.data.attributes['pagina_opera']" target="_blank">{{artifact.data.attributes['link_label']}}</a>
									</div>
								</template>
							</div>
						</div>
<!-- 						<div v-if="thereAreSomeRelated" class="stack-horizontal related-artifacts-label main-label pointer" @click="toggleRelatedArtifacts(true)" data-align="center" data-justify="start">
							<div class="stack-horizontal related-artifacts-label-content">
								<p class="capitalize-first">{{$t('related_artifacts')}}</p>
								<base-icon name="up_arrow" ></base-icon>
							</div>
						</div> -->
					</div>
				</div>
				<div class="artifact-medias-cont stack-vertical relative">
					<div v-if="artifactMedias.length > 1" class="stack-horizontal artifact-medias-spots" data-align="center" data-justify="center">
						<div v-for="(am, i) in artifactMedias" @click="setArtifactMedia(i)" :class="'artifact-media-item-spot pointer '+(i == currentArtifactMedia ? 'active' : '')"></div>
					</div>
					<div :class="'grid-horizontal artifact-medias ' + (artifactMedias.length > 1 ? 'more-medias' : '')" :style="artifactMediaStyle">
						<div v-for="media in artifactMedias" :class="`stack-horizontal artifact-media relative pointer ${media.type == 'application' ? 'pdf-media' : ''}`" data-justify="center">
							<div v-if="media.type == 'image'" class="stack-vertical" data-align="center">
								<img class="artifact-media-img" :src="fallbackSafariImages(media.imageFormats.large)" :data-id="media.id">
								<img :src="fallbackSafariImages(media.imageFormats.original)" class="artifact-media-original">
								<div v-show="false" class="artifact-media-zoom-icon pointer generic-shadow">
									<base-icon name="zoom-opera"/>
								</div>
							</div>
							<video v-else-if="media.type == 'video'" class="artifact-media-video" :src="media.url" controls></video>
							<audio v-else-if="media.type == 'audio'" class="artifact-media-video" :src="media.url" controls></audio>
							<!-- <a v-else :href="media.url" target="_blank" controls class="artifact-media-audio">file</a> -->
							<base-button v-else type="variant3" :text="$t('generic_apri_file')" @clicked="goSeePdf(media.url)"/>
							<!-- <p>{{media.url}}</p> -->
							<!-- <base-button v-else type="variant3" :text="$t('generic_apri_file')" @clicked="utils.openBlankUrl(media.url)"/> -->
						</div>
					</div>
				</div>
			</section>
		</div>
		<section v-if="thereAreSomeRelated" :class="'related-artifacts-cont '+(relatedActive ? 'active' : '')">
			<div class="stack-vertical related-artifacts-stack">
				<div class="stack-horizontal related-artifacts-label second-label pointer" @click="toggleRelatedArtifacts(!relatedActive)" data-align="center" data-justify="start">
					<div class="stack-horizontal related-artifacts-label-content">
						<p class="capitalize-first">{{$t('related_artifacts')}}</p>
						<!-- <base-icon name="down_arrow" ></base-icon> -->
						<base-icon :name="relatedActive ? 'down_arrow' : 'up_arrow'" ></base-icon>
					</div>
				</div>
				<div class="related-artifacts stack-horizontal">
					<div
						v-for="ri in relatedArtifacts"
						@click="goToArtifact(ri.id)"
						class="related-item stack-vertical pointer"
					>
						<img class="small-radius light-shadow related-item-media" :src="utils.parseMediaUrl(ri.image)">
						<div class="font-paragrafo-scrolly font-medium">{{ri.titolo}}</div>
						<div class="font-paragrafo-scrolly">{{ri.Autore}}{{ri.Autore && ri.Autore ? ' – ' : ''}}{{ri.anno_testo}}</div>
					</div>
				</div>
			</div>
		</section>
	</main>
	<div :class="'artifact-media-zoom-controller stack-horizontal ' + (atLeastOneZoomActive ? '' : 'disabled')" data-gap="none" data-align="center">
		<base-icon name="i-delete-1" class="artifact-media-remove-zoom pointer"/>
		<div class="artifact-media-zoom-bar pointer">
			<div class="artifact-media-zoom-progress" :style="zoomBarStyle"></div>
		</div>
		<base-icon name="i-add-1" class="artifact-media-add-zoom pointer"/>
	</div>
	<div :class="'artifact-exit-zoom-btn pointer generic-shadow '+(atLeastOneZoomActive ? 'show' : '')" @click="closeZoom">
		<base-icon name="e-remove-2"/>
	</div>
</template>

<script type="text/javascript">

import { nextTick } from 'vue';
import API from '@js/API.js';
import utils from '@js/utils.js';
import scrollies from '@static/scrollies.js';
import "viewerjs/dist/viewer.css";
import Viewer from "viewerjs/dist/viewer.js";
import { mapGetters, mapState, mapActions } from 'vuex';
import cloneDeep from 'lodash.clonedeep';

export default {
	name: 'ViewArtifact',
	data() {
		return {
			artifact: {},
			utils: utils,
			relatedArtifacts: [],
			relatedActive: false,
			canClickRelativeField: true,
			currentArtifactMedia: 0,
			zoomers: [],
			zoomBarValue: 0.3,
			zoomBarStep: 0.1,
			imageZoomActive: false,
			atLeastOneZoomActive: false,
			zoomBarStyle: '',
			relatedItemsMoved: false,
			buttonActions: {
				loaded: false,
				buttons: [
					{name: 'zoom', enabled: false, icon: 'zoom-in-1'},
					{name: 'download', enabled: false, icon: 'data-download-1'},
				]
			},
			scrollies: scrollies.scrollies,
			utils
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		...mapState(['scrollys']),
		artifactExists() {
			return !utils.isEmpty(this.artifact)
		},
		groupMetadata1() {
			return this.artifactMetadata.slice(1,5)
		},
		groupMetadata2() {
			return this.artifactMetadata
		},
		artifactMedias() {
			if(!this.artifact.data.attributes.media.data) return []

			return this.artifact.data.attributes.media.data.map((el, i) => {
				let type = utils.mimeToType(el.attributes.mime);
				let rtn = {
					id: i,
					type: utils.mimeToType(el.attributes.mime)
				}
				if(type == 'image') {
					console.log(cloneDeep(el.attributes.formats))
					rtn.imageFormats = {
						small: utils.parseMediaUrl(el.attributes.formats.small.url),
						large: utils.parseMediaUrl(el.attributes.formats.medium ? el.attributes.formats.large.url : el.attributes.formats.small.url),
						original: this.isMobile ? utils.urlToPicture(el.attributes.formats, ['large', 'small']) : utils.urlToPicture(el.attributes.formats, ['x-large', 'large', 'small']),
						originalPng: el.attributes.formats.large.url.replace('large_', 'large-png_').replace('.avif', '.png')
					}
				}else {
					// console.log('type', type)
					rtn.url = utils.parseMediaUrl(el.attributes.url)
				}
				return rtn;
			})
		},
		thereAreSomeRelated() {
			// console.log('related', cloneDeep(this.artifact.data.attributes))
			return this.artifact ? this.artifact.data.attributes.reperti_correlati.data.length : false
		},
		artifactPaths() {
			return this.scrollys.filter(scrolly => scrolly.attributes.reperto.some(r => r.reperto.data && r.reperto.data.id == this.artifact.data.idIT));
		},
		artifactMediaStyle() {
			return `left: calc((var(--media-container-width) * ${this.currentArtifactMedia} * -1 - (${this.currentArtifactMedia} * var(--media-padding))) + var(--media-padding));`
		},
		artifactMetadata() {
			return [
				{value: this.$t('reperto_metadata_titolo'),key: 'titolo'},
				{value: this.$t('reperto_metadata_autore'),key: 'Autore'},
				{value: this.$t('reperto_metadata_anno'),key: 'anno_testo'},
				{value: this.$t('reperto_metadata_tipologia'),key: 'tipologia'},
				{value: this.$t('reperto_metadata_tecnica'),key: 'tecnica'},
				{value: this.$t('reperto_metadata_dimensioni'),key: 'dimensioni'},
				{value: this.$t('reperto_metadata_lingua'),key: 'audio_lingua'},
				{value: this.$t('reperto_metadata_pagina_opera'),key: 'pagina_opera'},
				{value: this.$t('reperto_metadata_pagina_note'),key: 'note'},
				{value: this.$t('reperto_metadata_luogo'),key: 'luogo_conservazione'},
				// {value: this.$t('reperto_metadata_descrizione'),key: 'descrizione'},
				{value: this.$t('reperto_metadata_crediti'),key: 'crediti'},
			]
		},
		isCruscaVocabulary() {
			return this.artifact ? this.artifact.data.attributes.titolo == 'Vocabolario degli Accademici della Crusca' : false
		}
	},
	watch: {
		//'$route': function(n, o) {
		//	if(/\/archive\/\d+/.test(n.path) && /\/archive\/\d+/.test(o.path)) location.reload()
		//},
		zoomBarValue(n) {
			this.zoomBarStyle = `width: ${utils.map(n, 0.30, 1, 0, document.querySelector('.artifact-media-zoom-bar').clientWidth)}px;`
		},
		currentArtifactMedia(n) {
			this.updateActionButtons();
		}
	},
	methods: {
		...mapActions(['setCurrentPdfLink']),
		async getArtifact(id) {
			let res = await API.getArtifact({
				id: id,
				fields: [
					'titolo', 
					'Autore', 
					'anno',
					'anno_testo', 
					'tecnica',
					'luogo_conservazione',
					'descrizione',
					'open_access',
					'note',
					'dimensioni',
					'tipologia',
					'audio_lingua',
					'crediti',
					'link_label',
					'pagina_opera'
					// 'reperti_correlati'
				],
				populate: ['anteprima', 'media', 'reperti_correlati', 'percorsi', 'localizations']
			})

			res = await res.json();
			const correctLocale = res.data?.attributes.localizations.data.find(l => l.attributes.locale == this.$router.currentRoute.value.params.lang);
			if (correctLocale && correctLocale.attributes.publishedAt) {
				this.$router.replace({ params: { id: correctLocale.id } });
				location.href = this.$router.resolve({ params: { id: correctLocale.id } }).href;
				return;
			}

			// console.log('here')

			const itLocale = res.data?.attributes.localizations.data.find(l => l.attributes.locale == 'it');
			res.data.idIT = itLocale?.id ?? res.data.id;
			// if(this.$router.currentRoute.value.params.lang == 'en') {
			// 	let localizedData = res.data.attributes.localizations.data.find(el => el.attributes.locale == 'en')
			// 	// console.log('--- res ---', res.data.attributes.localizations.data.find(el => el.attributes.locale == 'en'))
			// 	res.data.attributes.titolo = localizedData.attributes.titolo
			// 	res.data.attributes.descrizione = localizedData.attributes.descrizione
			// }

			this.artifact = res
			await nextTick();
			console.log(cloneDeep(this.artifact));
			if(this.isMobile) {
				this.setMobileMediasListeners();
			}
			this.setZoomListeners();
			this.setZoomBarListeners();
			this.updateActionButtons();
			if(this.thereAreSomeRelated) {
				this.getRelatedArtifacts().then(res => {
					this.relatedArtifacts = res
					// console.log('related artifacts', cloneDeep(res))
					this.setRelatedListeners();
					this.addScrollRelativesOnDrag();
				})
			}

			if(this.artifact.data.attributes.media.data) {
				let firstMedia = this.artifact.data.attributes.media.data[0]
				if(utils.mimeToType(firstMedia.attributes.mime) == 'video' && firstMedia.subs) {
					this.loadVideoTracks(firstMedia.subs)
				}						
			}

				// })
				// .catch(err => {
				// 	// console.log('err', err.response)
				// })
		},
		loadVideoTracks(subs) {
			Array.from(this.$refs.myArtifact.querySelector('.artifact-medias video').querySelectorAll('track')).forEach(t => t.remove())

			subs.forEach(sub => {
				var track = document.createElement("track");
				track.mode = "showing";
				track.label = sub.lang == 'en' ? "English" : "Italian";
				track.kind = "subtitles";
				track.srclang = sub.lang;
				// track.src = this.subsVideo;
				track.default = true;
				this.$refs.myArtifact.querySelector('.artifact-medias video').appendChild(track);

				utils.loadTrackWithAjax(track, sub.url)
			})
		},
		async getRelatedArtifacts() {
			let localArr = []
			for(var ra of this.artifact.data.attributes.reperti_correlati.data) {
				let el = await API.getArtifact({
					id: ra.id,
					fields: [
						'titolo',
						'autore',
						'anno_testo',
					],
					populate: ['anteprima', 'media']
				})
				el = await el.json()
				// console.log('newEl before being parsed', cloneDeep(el))
				let newEl = {
					...el.data.attributes,
					id: el.data.id
				}
				// newEl.image = cloneDeep(newEl.anteprima.data?.attributes.url ?? "")
				newEl.image = newEl.anteprima.data ? 
					utils.parseMediaUrl(newEl.anteprima.formats.medium?.url) : 
					(newEl.media ? newEl.media.data[0].attributes.formats['medium'].url : '')

				// console.log('related artifacts parsed', cloneDeep(newEl))
				localArr.push(newEl);
			}
			return localArr
		},
		toggleRelatedArtifacts(bool) {
			if(!this.canClickRelativeField) return

			let endTransition = e => {
				if(e.propertyName == 'transform') {
					if(!this.relatedActive){
						document.querySelector('.related-artifacts-cont').style.top = '100%';
						// document.querySelector('.related-artifacts-cont').style.zIndex = '0';
						document.querySelector('.related-artifacts-stack').style.top ='0'
					}
					this.canClickRelativeField = true
				}
			}
			if(bool) {
				document.querySelector('.related-artifacts-stack').style.top ='100%'
				document.querySelector('.related-artifacts-cont').style.top = this.isMobile ? 'var(--menu-size)' : '0';
				// document.querySelector('.related-artifacts-cont').style.zIndex = '1';
				// document.querySelector('.related-artifacts-label.second-label').style.display = 'visible';
			}
			this.canClickRelativeField = false;
			document.querySelector('.related-artifacts-stack').ontransitionend = endTransition
			this.relatedActive = bool
		},
		relativeListener(e) {
			if(Array.from(e.target.classList).indexOf('related-artifacts-cont') > -1) {
				if(this.relatedActive) {
					this.toggleRelatedArtifacts(false)
				}
			}
		},
		setRelatedListeners() {
			document.body.addEventListener('click', this.relativeListener)
			document.querySelector('.related-artifacts-stack').style.top ='0'
			// document.querySelector('.related-artifacts-cont').onclick = e => {
			// 	this.toggleRelatedArtifacts(false)
			// }
		},
		async addPdfViewerNavigationOnClick(item) {
			let res = await API.getMediaByName({filters: [{type: 'name', value: 'Crusca_vocabulary_linearized.pdf'}]})
			res = await res.json();
			if(!res.length) return 

			let link = res[0].url;
			this.setCurrentPdfLink(link);

			let goToPdfReader = e => {
				this.$router.push({ name: 'PdfViewer'})
			}

			item.addEventListener('click', goToPdfReader);
		},
		setZoomListeners() {
			utils.isElLoaded('.artifact-media-zoom-icon')
				.then(() => {
					Array.from(document.querySelectorAll('.artifact-media-zoom-icon')).forEach((zoomIcon, i) => {
						let me = this;
						utils.isImageLoaded(zoomIcon.previousSibling)
							.then(res => {
								let originalMedia = document.querySelector('.artifact-media-original')
								let zoomElement = {id: i, originalMedia, zoomIcon: zoomIcon}
								console.log('isCruscaVocabulary', me.isCruscaVocabulary)
								if(me.isCruscaVocabulary) {
									me.addPdfViewerNavigationOnClick(zoomIcon.previousSibling);
								}else {
									zoomElement.viewer = new Viewer(zoomIcon.previousSibling, {
										navbar: false,
										toolbar: false,
										button: false,
										title: false,
										movable: true,
										zoom: 0.3,
										maxZoomRatio: 1,
										minZoomRatio: 0.30,
										ready: function() {
											// console.log('ready callback')
										},
										viewed: function() {
											console.log('VIEWED')
											this.viewer.zoom(0.3)
											me.atLeastOneZoomActive = true
											// console.log('viewed event')
											me.zoomBarValue = 0
											setTimeout(() => {me.zoomBarValue = 0.30}, 1)
											// console.log('zoom activated')
											// zoomElement.viewer.zoomTo(2)
											document.querySelector('body.artifact #app').style.position = 'absolute'
											document.querySelector('body.artifact').style.position = 'absolute'
										},
										hide: e => {
											// console.log('hide event')
											this.atLeastOneZoomActive = false
											this.zoomBarValue = 0
											document.querySelector('body.artifact #app').style.position = 'fixed'
											document.querySelector('body.artifact').style.position = 'fixed'
										}
									})
									this.zoomers.push(zoomElement)
									// console.log(cloneDeep(zoomElement.viewer))
									zoomIcon.onclick = e => {
										zoomElement.viewer.show()
									}
									zoomIcon.parentElement.querySelector('.artifact-media-img').onclick = e => {
										console.log('hereee')
										zoomElement.viewer.show()
									}

									zoomIcon.previousSibling.addEventListener('zoom', e => {
										this.zoomBarValue = e.detail.ratio
									})
								}

							})
					})
				})
		},
		setZoomBarListeners() {
			utils.isElLoaded('.artifact-media-add-zoom')
				.then(() => {
					let assignZoom = () => {
						this.zoomers.find(z => z.viewer.viewed).viewer.zoomTo(this.zoomBarValue)
					} 
					document.querySelector('.artifact-media-add-zoom').onclick = e => {
						this.zoomBarValue = (this.zoomBarValue + this.zoomBarStep) >= 3 ? 3 : this.zoomBarValue + this.zoomBarStep
						assignZoom()
					}
					document.querySelector('.artifact-media-remove-zoom').onclick = e => {
						this.zoomBarValue = (this.zoomBarValue - this.zoomBarStep) <= 0.3 ? 0.3 : this.zoomBarValue - this.zoomBarStep
						assignZoom()
					}
					document.querySelector('.artifact-media-zoom-bar').onclick = e => {
						this.zoomBarValue = utils.map(e.offsetX, 0, document.querySelector('.artifact-media-zoom-bar').clientWidth, 0, 3)
						assignZoom()
					} 
				})
		},
		setMobileMediasListeners() {
			// console.log('started listener')
			let touchActive = false;
			let prevX = null;
			let delta = 0;
			utils.isElLoaded('.artifact-medias')
				.then(() => {
					let container = document.querySelector('.artifact-medias')
					container.ontouchstart = e => {
						// console.log('touchstart')
						touchActive = true
						container.style.transitionDuration = '0s'
					}
					container.ontouchmove = e => {
						// console.log('touchmove')
						if(touchActive) {
							// console.log(e)
							let currentX = e.touches[0].clientX;
							if(prevX === null) {
								prevX = currentX;
							}
							delta = currentX - prevX
							// container.style.left = `calc(var(--media-padding) + ${delta}px)`
						}
					}
					container.ontouchend = e => {
						// console.log('touchend', delta)
						// if(Math.abs(delta) > 0) {
							if(delta < 0) {
								this.setArtifactMedia(this.currentArtifactMedia+1)
							}else {
								this.setArtifactMedia(this.currentArtifactMedia-1)
							}
						// }
						touchActive = false
						container.style.transitionDuration = '.5s'
					}
				})
		},
		async goToArtifact(id) {
			if(!this.relatedItemsMoved) {
				await this.$router.push({ name: 'artifact', params: {id} });
				// location.reload()
			}
		},
		goToArchive() {
			if(window.history.state.back) window.history.back()
			else this.$router.push({ name: 'archive' })
		},
		setArtifactMedia(index) {
			if(index >= 0 && index < this.artifactMedias.length) this.currentArtifactMedia = index;
		},
		closeZoom() {
			this.zoomers.find(z => z.viewer.viewed).viewer.hide()
		},
		addScrollRelativesOnDrag() {
			// special thanks to https://gist.github.com/AlexGh12
			const slider = document.querySelector('.related-artifacts');
			let isDown = false;
			let startX;
			let scrollLeft;
			let timer = new Date();

			slider.onmousedown = (e) => {
				e.preventDefault()
			  
				timer = new Date();
			  isDown = true;
			  slider.classList.add('active');
			  startX = e.pageX - slider.offsetLeft;
			  scrollLeft = slider.scrollLeft;
			};
			slider.onmouseleave = () => {
			  isDown = false;
			  slider.classList.remove('active');
			};
			slider.onmouseup = () => {
			  isDown = false;
			  slider.classList.remove('active');
				// setTimeout(() => this.relatedItemsMoved = false, 1);
				if(new Date().getTime() - timer.getTime() < 100) {
					this.relatedItemsMoved = false
				}else {
					setTimeout(() => this.relatedItemsMoved = false, 500)
				}
			};
			slider.onmousemove = (e) => {
			  if(!isDown) return;

			  this.relatedItemsMoved = true
			  const x = e.pageX - slider.offsetLeft;
			  const walk = (x - startX); //scroll-fast
			  slider.scrollLeft = scrollLeft - walk;
			};
		},
		goBack() {
			window.history.back();
		},
		clickButton(name) {
			let currentFile = this.artifactMedias[this.currentArtifactMedia]

			console.log('artifactMedias', cloneDeep(currentFile))

			if(!this.buttonActions.buttons.find(el => el.name == name).enabled) return

			switch(name) {
				case 'download':
					let type = currentFile.type
					utils.downloadFile(type == 'image' ? currentFile.imageFormats.original : currentFile.url, type)
					break;
				case 'zoom':
					document.querySelector(`.artifact-media-img[data-id="${this.currentArtifactMedia}"]`).click()
					break;
			}
		},
		updateActionButtons() {
			if(!this.artifact.data.attributes.open_access) {
				this.buttonActions.buttons.find(el => el.name == 'download').enabled = false
			} else {
				this.buttonActions.buttons.find(el => el.name == 'download').enabled = true
			}

			if(this.artifactMedias[this.currentArtifactMedia].type == 'image') {
				this.buttonActions.buttons.find(el => el.name == 'zoom').enabled = true
			} else {
				this.buttonActions.buttons.find(el => el.name == 'zoom').enabled = false
			}
		},
		fallbackSafariImages(url) {
			if(utils.areAvifSupported()) {
				return url
			}else {
				return url.replace('avif', 'jpg')
			}
		},
		goSeePdf(link) {
			this.setCurrentPdfLink(link);
			this.$router.push({ name: 'PdfViewer'})
		}
	},
	mounted() {
		this.getArtifact(this.$route.params.id)
	},
	beforeUnmount() {
		document.body.removeEventListener('click', this.relativeListener);
	}
}
</script>

<style lang="scss">

	@import '@css/variables.scss';

	.page.single-artifact {
		overflow: hidden !important;
	}

	.artifact-back-page {
		font-family: 'Arzachel';
		font-size: 0.95rem;
		text-decoration: underline;
	}

	.artifact-back-page.svg-icon {
		width: 27px;
	}

	.artifact-cont {
		--artifact-grid-gap: 0;
		width: 100%;
		grid-template-columns: 636px 5fr;
		gap: var(--artifact-grid-gap);
	}
	
	.artifact-data-cont {
		padding: 1.5rem 3rem 3rem 3rem;
		overflow-y: auto;
		min-height: fit-content;
		gap: 1.5rem;
	}

	.supplementary-data-cont {
		height: calc(100vh);
		overflow-y: auto;
		// min-height: fit-content;
	}

	.supplementary-data-cont.with-margin {
		height: calc(100vh - var(--s4) - 1.5rem);
	}

	.artifact-data {
		gap: 3rem;
	}

	.artifact-data-main-group {
		gap: var(--s3);
	}

	.artifact-data-group {
		gap: var(--s0);
	}

	.artifact-desc {
		gap: var(--s1);
	}

	.artifact-metadata-cont {
		padding-top: var(--s2);
		border-top: solid 2px var(--color-gray);
	}

	.artifact-metadata-title {
		margin: var(--s1) 0;
	}

	.artifact-metadata {
		gap: 0.5rem;
		width: 100%;
		grid-template-columns: 12rem auto;
	}

	.metadata-voice {
		height: fit-content;
	}

	.artifact-medias-cont {
		--media-padding: 4.75rem;
		background-color: var(--color-light-gray);
		justify-content: center;
		align-items: center;
/*		padding: 0 4.75rem 4.75rem 4.75rem;*/
		height: 100vh;
		overflow: hidden;
	}

	.artifact-medias {
		--media-container-width: calc(((100vw - var(--menu-size)) - 636px) - (var(--media-padding) * 2));
		position: absolute;
		top: var(--media-padding);
		left: var(--media-padding);
		grid-template-columns: repeat(5, var(--media-container-width));
		gap: var(--media-padding);
		height: calc(100% - var(--media-padding) * 2);
		transition-property: left;
		transition-duration: .5s;
		transition-timing-function: ease-in-out;
	}

	.artifact-media {
		width: var(--media-container-width);
		height: calc(100vh - 2 * var(--menu-size));
		gap: 0.5;
	}

	.artifact-media img {
		object-fit: contain;
		height: 100%;
		width: 100%;
		position: absolute;
		z-index: 1;
	}

	.artifact-media video {
		max-width: 100%;
		max-height: 100%;
		align-self: center;
	}

	.artifact-media audio {
		width: 100%;
		align-self: center;
	}

	.artifact-media-original {
		width: 0;
		height: 0;
	}

	.artifact-media-zoom-icon {
		position: absolute;
		bottom: 3rem;
		left: 0;
		right: 0;
		margin: auto;
		width: fit-content;
		background-color: var(--color-white);
		z-index: 0;
		padding: var(--s1);
		border-radius: 100rem;
		--svg-icon-color: var(--color-black);
	}

	.artifact-medias-spots {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: var(--media-padding);
		gap: var(--s1);
		// z-index: 1;
	}

	.artifact-media-item-spot {
		width: 0.87rem;
		height: 0.87rem;
		background-color: var(--color-light-gold);
		border-radius: 100rem;
	}

	.artifact-media-item-spot.active {
		background-color: var(--color-dark-gold);
	}

	.artifact-media-zoom-controller {
		position: absolute;
		left: calc(50% - var(--menu-size)/2);
		transform: translateX(-50%);
		bottom: 3.6rem;
		opacity: 1;
		transition-property: opacity;
		transition-duration: .5s;
		transition-timing-function: ease-in-out;
		z-index: 3000;
	}

	.artifact-media-zoom-controller.disabled {
		opacity: 0;
		z-index: -1;
	}

	.artifact-media-zoom-controller .svg-icon {
		--svg-icon-color: var(--color-white);
	}

	.artifact-media-zoom-bar {
		width: var(--s6);
		background-color: var(--color-gray-opacity);
		height: 0.75rem;
		border-radius: 100rem;
		overflow: hidden;
	}

	.artifact-media-zoom-progress {
		background-color: var(--color-gray);
		height: 100%;
	}

	.artifact-exit-zoom-btn {
		position: absolute;
		top: 4.5rem;
		right: 4.5rem;
		padding: var(--s1);
		background-color: var(--color-gold);
		border-radius: 100rem;
		// z-index: 3000;
		animation: zoom-exit-hide;
		animation-fill-mode: forwards;
		animation-duration: .5s;
		opacity: 0;
	}

	.artifact-exit-zoom-btn.show {
		animation: zoom-exit-show;
		animation-fill-mode: forwards;
		animation-duration: .5s;
		z-index: 3000;
	}

	@keyframes zoom-exit-show {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@keyframes zoom-exit-hide {
		0% {
			z-index: 3000;
		}
		100% {
			opacity: 0;
			z-index: -1;
		}
	}

	.related-artifacts-cont {
		position: absolute;
		left: 0;
		top: 100%;
		// top: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		background-color: rgba(0,0,0,0);
		transition-property: background-color;
		transition-duration: .5s;
		transition-timing-function: ease-in-out;
	}

	.related-artifacts-cont.active {
		background-color: rgba(0,0,0,0.5);
	}

	.related-artifacts-stack {
		position: absolute;
		top: 100%;
    bottom: 0;
    width: 100%;
		height: fit-content;
		gap: 0;
		z-index: 1;
		transform: translate(0, calc(var(--s4) * -1));
		transition-property: transform;
		transition-duration: 1s;
		transition-timing-function: ease-in-out;
	}

	.related-artifacts-cont.active .related-artifacts-stack {
		top: 100%;
		transform: translate(0,calc(-100% ));
	}

	.related-artifacts {
		width: 100%;
		padding: 4.4rem 3rem 2rem 3rem;
		overflow-x: auto;
		overflow-y: hidden;
		z-index: 1;
		background-color: var(--color-gold);
		gap: var(--s3);
	}

	.related-artifacts-label {
		position: absolute;
		left: 0;
		bottom: 0;
		width: calc(100% + var(--artifact-grid-gap));
		height: var(--s4);
		background-color: var(--color-gold);
	}

	.related-artifacts-label.main-label {
		position: fixed;
		left: var(--menu-size);
		width: calc(((100vw - var(--menu-size)) / 3));
	}

	.related-artifacts-label.second-label {
		position: relative;
		margin-bottom: -1px;
		// width: calc(100% / 3);
		width: 636px;
		z-index: -1;
		transition-property: top;
		transition-duration: 1s;
		transition-timing-function: ease-in-out;
	}

	.related-artifacts-label-content {
		align-items: center;
		margin: 0 var(--s3);
	}

	.related-artifacts-label-content .svg-icon {
		width: 1.4rem;
		height: 1.4rem;
	}

	.related-item {
		justify-content: flex-start;
		gap: var(--s1);
		min-width: 16rem;
		height: fit-content;
	}

	.related-item-media {
		max-height: 60vh;
	}

	.viewer-backdrop {
		background-color: var(--color-black);
	}

	.artifact-button-actions {
		gap: 1.5rem;
		height: var(--s3);
	}

	.artifact-button-actions .artifact-public-domain-icon {
		width: 90px;
		height: 32px;
	}

	.artifact-button-action.disabled {
		--svg-icon-color: var(--color-gray);
		cursor: unset;
	}
	
	.pdf-media {
		height: fit-content;
		align-self: center;
	}

	@media (max-width: $breakpoint-m) {

		.artifact-medias-cont {
			--media-padding: 1rem;
		}

		.artifact-medias {
			--media-container-width: calc(((100vw - var(--menu-size)) - 636px) - (var(--media-padding) * 2));
		}

		.artifact-cont {
			grid-template-columns: 636px 5fr;
		}

		.artifact-medias-spots {
	    height: fit-content;
	    top: var(--s1);
		}
	}

	@media (max-width: $breakpoint-sm + 300px) {
		.artifact-medias {
			--media-container-width: calc(((100vw - var(--menu-size)) - 450px) - (var(--media-padding) * 2));
		}

		.artifact-cont {
			grid-template-columns: 450px 5fr;
		}
		.related-artifacts-label.second-label {
			width: 450px;
		}
	}

	@media (max-width: $breakpoint-sm) {
		.supplementary-artifact-cont {
			overflow-y: scroll;
			height: 100vh;
			padding-bottom: 4rem;
		}

		.supplementary-data-cont {
			height: unset;
			margin-bottom: 0;
			overflow: hidden;
			min-height: calc(100vh - var(--menu-size));
			// margin-bottom: var(--s3);
		}

		.supplementary-data-cont.with-margin {
			height: unset;
		}

		.artifact-cont {
			display: flex;
			flex-direction: column-reverse;
			overflow: hidden;
		}

		.artifact-data {
			gap: 2rem;
			padding-bottom: 5rem;
		}

		.artifact-data-cont {
			--artifact-data-padding: 1.25rem;
			padding: 0 var(--artifact-data-padding);
			// height: 100%;
			// overflow: hidden;
			margin-top: var(--s3);
		}

		.related-item {
			min-width: 10rem;
			// min-width: unset;	
			padding-bottom: 5rem;
		}

		.related-item-media {
			max-height: 30vh;
		}

		.artifact-metadata-cont {
			padding-top: var(--s1);
		}

		.artifact-data-group {
			gap: var(--s0);
		}

		.artifact-medias-cont {
			--media-padding: 1.25rem;
			--media-container-height: 20.3rem;
			height: var(--media-container-height);
		}

		.artifact-medias.more-medias {
			top: calc(var(--media-padding) * 2);
			height: calc(var(--media-container-height) - (var(--media-padding) * 2));
		}

		.artifact-media {
			height: calc(var(--media-container-height) - (var(--media-padding) * 2));
		}

		.artifact-medias {
			--media-container-width: calc(100vw - (var(--media-padding) * 2));
			position: absolute;
			top: var(--media-padding);
			left: var(--media-padding);
			grid-template-columns: var(--media-container-width) var(--media-container-width);
			gap: var(--media-padding);
			height: var(--media-container-height);
		}

		.artifact-medias-spots {
			top: calc(var(--media-padding) / 2);
		}

		.artifact-media-zoom-controller {
	    left: 50%;
	    transform: translateX(-50%);
	    bottom: 5rem;
		}

		.artifact-media-zoom-bar {
			width: 50vw;
		}

		.related-artifacts-label.main-label { position: fixed;
			margin-left: calc(var(--artifact-data-padding) * -1);
			margin-right: calc(var(--artifact-data-padding) * -1);
			left: unset;
			width: calc(100% + (var(--artifact-data-padding) * 2));
			// z-index: 20;
			bottom: 0;
			// bottom: calc(var(--s4) * -1);
			transition-property: bottom;
			transition-duration: .5s;
		}

		.related-artifacts-label.second-label {
			width: 100%;
		}

		.related-artifacts-cont {
			position: fixed;
	    max-height: calc(100vh - var(--menu-size));
		}

		.related-artifacts-cont .related-artifacts-stack {
      overflow: auto;
		}

		.related-artifacts-cont.active {
			background-color: rgba(0,0,0,0.5);
		}

		.related-artifacts-cont.active .related-artifacts-stack {
			transform: translate(0,calc(-100% ));
		}

		.related-artifacts {
			width: 100%;
			padding: 2rem;
			overflow-x: auto;
			overflow-y: hidden;
			z-index: 1;
			background-color: var(--color-gold);
			gap: var(--s3);
		}

		.artifact-exit-zoom-btn {
			position: absolute;
			top: 1.5rem;
			right: 1.5rem;
		}
	}

</style>
